<template>
	<div>
		
		<van-nav-bar title="添加新群" fixed placeholder left-text="返回" left-arrow @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<van-button type="primary" size="large" @click="refresh">刷新</van-button>
		<van-empty description="没有新群" image="search" v-if="!list.length && show_empty" />
		
		<van-list>
			<van-cell @click="getUnusedList(index)" v-for="(item, index) in list" :key="item.id" :title="item.nickname" is-link
			 size="large" />
		</van-list>

		<van-dialog v-if="select_index>=0" v-model="show" @confirm="selectConfirm" @cancel="selectCancel" :title="'选择版本 · ' + list[select_index].nickname"
		 show-cancel-button>
			<div style="padding: 2em;max-height: 10em;overflow-y: scroll;">
				<van-radio-group v-model="radio">
					<van-radio :style="{padding: '.5em 0'}" v-for="(item, index) in unused_list" :name="item.id" icon-size="22px"
					 shape="square">{{item.title}}({{item.day}}天）<span style="color: #42B983;">x{{item.count}}</span></van-radio>
				</van-radio-group>
			</div>
		</van-dialog>

	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		List,
		Cell,
		ActionSheet,
		RadioGroup,
		Radio
	} from 'vant';

	Vue.use(List);
	Vue.use(Cell);
	Vue.use(ActionSheet);
	Vue.use(Radio);
	Vue.use(RadioGroup);
	export default {
		data() {
			return {
				loading: false,
				finished: false,
				list: [],
				unused_list: [],
				show: true,

				select_index: -1,

				radio: 0,
				
				show_empty: false
			}
		},
		created() {
			this.get()
		},
		methods: {
			onClickLeft() {
				this.$router.back()
			},
			get() {
				this.$ApiUtil.Group.get().then(res => {
					this.list = res.list
					this.show_empty = true
				})
			},
			refresh() {
				this.$ApiUtil.Group.refresh().then(res => {
					this.list = res.list
				})
			},
			getUnusedList(e) {

				this.$ApiUtil.Group.getUnusedList().then(res => {
					if (!res.status) {
						this.$dialog.alert({
							message: res.message
						}).then(() => {
							this.$router.push('/buy-center')
						})
						return;
					}
					this.select_index = e
					this.show = true
					this.unused_list = res.list
				})
			},
			selectConfirm() {
				if(!this.radio || this.select_index < 0) return;
				this.$ApiUtil.Group.selectGroup({
					oid: this.radio,
					group_id: this.list[this.select_index].id
				}).then(res => {
					if (res.status) {
						this.$router.push('/member-center')
						return;
					}
					this.$dialog.alert({
						message: res.message
					})
				})
			},
			selectCancel() {
				this.radio = 0
				this.select_index = -1
			}
		}
	}
</script>

<style>
</style>
